import { z } from 'zod';
import { ITEM_ID_RE } from './ids.js';
// ---------------------------------------------------------------------------
// Feedback events (canonical, append-only) + overlay projection.
// Ported from the daemon's schema.ts / feedback-store.ts / overlay.ts. In the
// hosted model these are Postgres rows (feedback_event append-only; overlay is a
// projection the read path merges onto the stored digest).
// ---------------------------------------------------------------------------
export const FEEDBACK_EVENT_ACTIONS = [
    'mark_done',
    'mark_not_relevant',
    'snooze_until',
    'add_note',
    'clear_snooze',
    'restore',
];
export const FeedbackEventSchema = z
    .object({
    event_id: z.string().min(1),
    created_at: z.string().min(1),
    item_id: z.string().regex(ITEM_ID_RE),
    action: z.enum(FEEDBACK_EVENT_ACTIONS),
    payload: z
        .object({
        until: z.string().optional(),
        text: z.string().optional(),
    })
        .strict()
        .default({}),
})
    .strict();
export const OVERLAY_STATUSES = ['active', 'done', 'not_relevant', 'snoozed'];
export const OverlayItemSchema = z
    .object({
    item_id: z.string(),
    status: z.enum(OVERLAY_STATUSES),
    snooze_until: z.string().nullable(),
    notes: z.array(z.string()),
    latest_note: z.string().nullable(),
    updated_at: z.string(),
})
    .strict();
/** Resolve time-dependent snoozes consistently across browser and catalog views. */
export function effectiveOverlayStatus(overlayItem, now = new Date()) {
    if (overlayItem?.status !== 'snoozed')
        return overlayItem?.status ?? 'active';
    if (!overlayItem.snooze_until)
        return 'active';
    const snoozeUntil = new Date(overlayItem.snooze_until);
    return Number.isNaN(snoozeUntil.getTime()) || snoozeUntil <= now ? 'active' : 'snoozed';
}
